import gql from 'graphql-tag'

export const fetchAutopayPaymentStatus = gql(`
query ($hash: String!, $orderNumber: String!)  {
  bluepaymentOrder(
    hash: $hash,
    order_number: $orderNumber
  ) {
    status
    bluepayment_state
    payment_methods{
        name
    }
  }
}
`)
